export const soaHeading = [
    { name: "INVOICE ID" },
    { name: "CHARGES" },
    { name: "CREDIT AMOUNT" },
    { name: "UNSETTLED BALANCE" },

];